<template>
  <div style="font-size: 14px">
    <!-- 主抽屉 -->
    <el-drawer title="推送列表" :visible.sync="isShow" direction="ltr" size="80%" :wrapperClosable="false" :withHeader="false">
      <el-divider style="margin: 0" />
      <div style="display: flex">
        <!-- 左侧列表按钮 -->
        <div class="menu-list">
          <div style="font-weight: 700; font-size: 18px; border-bottom: 1px solid #e0e0e0; padding-bottom: 20px; margin-bottom: 20px">推送列表</div>
          <div v-for="(item, i) in planList" :key="i">
            <div :class="['menu-list-item', { active2: item.isRun === 0 || item.isRun === 1 }, { active3: item.isOpen === 1 }, { selected: activeItemId === item.id }]" @click="setData(item, true)" :title="item.name">
              {{ item.name }}
            </div>
          </div>

          <!-- 占位提示 -->
          <template v-if="planList.length < 5">
            <div
              v-for="n in 5 - planList.length"
              :key="'placeholder-' + n"
              :class="['menu-list-item', { selected: activeItemId === 'placeholder-' + n }]"
              @click="
                setData(null, true)
                activeItemId = 'placeholder-' + n
              ">
              暂无数据源配置
              <span>&nbsp;&nbsp;(点击配置)</span>
            </div>
          </template>
        </div>

        <!-- 右侧表单设置 -->
        <div style="flex: 1; box-shadow: -3px 0 8px rgba(0, 0, 0, 0.1); position: relative">
          <div class="setBox">
            <!-- 顶部开关 -->
            <div class="setBox_top">
              <el-switch v-model="domainForm.isOpen" :active-value="1" :inactive-value="0" @change="isShowComputedFn" :width="60" :disabled="isSwitchDisabled" />
              <span class="setBox_top_text">推送面板展示</span>
            </div>

            <div class="setBox_content">
              <!-- 推送名称 -->
              <el-row>
                <el-col :span="24">
                  <div class="setBox_content_title setBox_content_titleActive">推送项目名称</div>
                </el-col>
                <el-col :span="24">
                  <el-input v-model="domainForm.name" type="text" placeholder="请输入推送项目名称" maxlength="30" show-word-limit size="large" />
                </el-col>
              </el-row>

              <!-- 数据源选择 -->
              <el-row>
                <el-col :span="24">
                  <div class="setBox_content_title setBox_content_titleActive">数据源选择</div>
                </el-col>
                <el-col :span="24">
                  <div class="setBox_content_title_btn" @click="addData">+&nbsp;添加数据源</div>
                  <div style="display: grid; grid-template-columns: 1fr 1fr 1fr">
                    <div v-for="(item, i) in domainForm.itemList" :key="i" class="drawer-inner-content-item">
                      <div>{{ item.sourceName }}</div>
                      <div class="close-icon">
                        <i class="el-icon-circle-close" @click="removeData(i)" />
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <!-- 推送模板 -->
              <el-row>
                <el-col :span="24">
                  <div class="setBox_content_title setBox_content_titleActive">推送模板</div>
                </el-col>
                <el-col :span="24">
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <div style="background: #f5f6fa; padding: 20px 10px 10px 20px">
                        <div style="height: 400px; overflow-y: auto; padding-right: 10px">
                          <div v-for="(item, i) in teamplanList" :key="i">
                            <el-button style="margin-bottom: 10px; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap" @click="setTemplate(item)" :type="domainForm.templateId == item.id ? 'primary' : ''">
                              {{ item.templateName }}
                            </el-button>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18">
                      <div style="height: 460px; overflow: hidden; border: 1px solid #e0e0e0; padding: 20px" v-html="templateContent"></div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>

              <!-- 提示音设置 -->
              <el-row>
                <el-col :span="24">
                  <div class="setBox_content_title setBox_content_titleActive">提示音设置</div>
                </el-col>
                <el-col :span="24">
                  <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr">
                    <el-button v-for="(audio, index) in audioList" :key="index" size="mini" :type="audio.id === domainForm.musicType ? 'primary' : ''" :disabled="isAudioDisabled(audio)" @click="setAudio(audio)">
                      <div class="drawer-inner-content-item_audio">
                        <div>{{ audio.name }}</div>
                        <span :class="['iconfont', audio.isPlaying ? 'icon-caozuo-bofang-zanting' : 'icon-bofang']" style="font-size: 20px" @click.stop="playAuto(index)" />
                      </div>
                    </el-button>
                  </div>
                </el-col>
              </el-row>

              <!-- 其他设置 -->
              <el-row>
                <el-col :span="24">
                  <div class="setBox_content_title">其他设置</div>
                </el-col>
                <el-col :span="24">
                  <div style="margin-bottom: 10px">
                    <el-checkbox v-model="isMutedComputed"> 提示音静音 </el-checkbox>
                  </div>
                  <div>
                    <el-checkbox v-model="isShowMediaComputed"> 展示图片与视频 </el-checkbox>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 底部按钮 -->
          <div class="footer">
            <el-divider />
            <div class="footer_btn">
              <!-- <el-button type="primary" plain @click="resetFn" style="margin-right: 10px;"> 重置 </el-button> -->
              <el-button type="primary" plain @click="cancelInnerDrawer"> 取消 </el-button>
              <el-button type="primary" @click="saveInnerDrawer"> 保存 </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 数据源弹窗 -->
    <el-dialog title="数据源设置" :visible.sync="dialogTableVisible" class="custom-dialog" :modal-append-to-body="false" width="1200px" :show-close="false" :close-on-click-modal="false">
      <div class="custom-dialog-content">
        <!-- 左侧 -->
        <div class="custom-dialog-content-left">
          <el-tabs v-model="activeName" tab-position="left" style="height: 200px" @tab-click="goAssignBlock(activeName)">
            <el-tab-pane label="精准舆情" name="one" />
            <el-tab-pane label="监测方案" name="two" />
            <el-tab-pane label="数据源" name="three" />
            <el-tab-pane label="热榜" name="four" />
          </el-tabs>

          <div ref="scrollContainer" class="custom-dialog-content-left-tabBox">
            <!-- 监测方案 -->
            <div ref="one">
              <div class="custom-dialog-content-left-tabBox-title">精准舆情</div>
              <div class="custom-dialog-content-left-tabBox-content">
                <div v-for="(item, i) in sourceType1" :key="i">
                  <el-button :type="isSelected(item) ? 'primary' : ''" style="width: 100%" :disabled="isDisabled(item)" @click="toggleDataSource(item)">
                    {{ item.sourceName }}
                  </el-button>
                </div>
              </div>
            </div>

            <!-- 精准舆情 -->
            <div ref="two">
              <div class="custom-dialog-content-left-tabBox-title">监测方案</div>
              <div class="custom-dialog-content-left-tabBox-content">
                <div v-for="(item, i) in sourceType2" :key="i">
                  <el-button :type="isSelected(item) ? 'primary' : ''" style="width: 100%" :disabled="isDisabled(item)" @click="toggleDataSource(item)">
                    {{ item.sourceName }}
                  </el-button>
                </div>
              </div>
            </div>

            <!-- 数据源 -->
            <div ref="three">
              <div class="custom-dialog-content-left-tabBox-title">数据源</div>
              <div class="custom-dialog-content-left-tabBox-content">
                <div v-for="(item, i) in sourceType3" :key="i">
                  <el-button :type="isSelected(item) ? 'primary' : ''" style="width: 100%" :disabled="isDisabled(item)" @click="toggleDataSource(item)">
                    {{ item.sourceName }}
                  </el-button>
                </div>
              </div>
            </div>

            <!-- 热榜 -->
            <div ref="four">
              <div class="custom-dialog-content-left-tabBox-title">热榜</div>
              <div class="custom-dialog-content-left-tabBox-content">
                <div v-for="(item, i) in sourceType4" :key="i">
                  <el-button :type="isSelected(item) ? 'primary' : ''" style="width: 100%" :disabled="isDisabled(item)" @click="toggleDataSource(item)">
                    {{ item.sourceName }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧已选 -->
        <div class="custom-dialog-content-right">
          <div class="custom-dialog-content-right-title">已选数据源</div>
          <div class="custom-dialog-content-right-content">
            <div v-for="(item, i) in tempItemList" :key="i">
              <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap" :title="item.sourceName">{{ item.sourceName }}</div>
              <div class="custom-dialog-content-right-content-close" @click="removeData(i, tempItemList)">
                <i class="el-icon-circle-close" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="canelData">取 消</el-button>
          <el-button type="primary" @click="submitData"> 确 定 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { domainSearch, listInsert, domainUpdate, domainAdd } from '@/api/fiveBar/index'
import { debounce } from 'lodash-es'

const url = 'https://www.yuqing.cn'
const SOURCE_TYPE = {
  PLAN: 0,
  OPINION: 1,
  REALTIME: 2,
  HOT: 4,
}

export default {
  name: 'MeunList',

  props: {
    planList: { type: Array, default: () => [] },
    isShow: { type: Boolean, default: false },
  },

  data() {
    return {
      userInfo: null,
      activeItemId: null,
      domainForm: {},
      domainFormCopy: {},
      dialogTableVisible: false,
      activeName: 'one',
      currentSourceType: null,
      loading: false,
      sourceType1: [],
      sourceType2: [],
      sourceType3: [],
      sourceType4: [],
      teamplanList: [],
      itemListCope: [],
      tempItemList: [],
      templateContent: '',
      audioList: [
        { name: '水滴声.mp3', id: 1, isPlaying: false, src: url + '/music/voice_one.mp3', audioElement: null },
        { name: '门铃声.mp3', id: 2, isPlaying: false, src: url + '/music/voice_two.mp3', audioElement: null },
        { name: '风铃声.mp3', id: 3, isPlaying: false, src: url + '/music/voice_three.mp3', audioElement: null },
        { name: '古筝声.mp3', id: 4, isPlaying: false, src: url + '/music/voice_four.mp3', audioElement: null },
        { name: '波浪声.mp3', id: 5, isPlaying: false, src: url + '/music/voice_five.mp3', audioElement: null },
      ],
      usedAudioIds: [],
    }
  },

  computed: {
    isShowComputed: {
      get() {
        return this.domainForm.isOpen === 1
      },
      set(val) {
        this.isShowComputedFn(val)
      },
    },
    isMutedComputed: {
      get() {
        return this.domainForm.isMuted === 1
      },
      set(val) {
        this.domainForm.isMuted = val ? 1 : 0
      },
    },
    isShowMediaComputed: {
      get() {
        return this.domainForm.isShowMedia === 1
      },
      set(val) {
        this.domainForm.isShowMedia = val ? 1 : 0
      },
    },
    isSwitchDisabled() {
      return !this.domainForm.name || !this.domainForm.itemList?.length || !this.domainForm.templateId || !this.domainForm.musicType
    },
  },

  watch: {
    planList: {
      handler() {
        this.updateUsedIds()
      },
      deep: true,
    },
    isShow() {
      this.activeItemId = this.planList[0]?.id
      this.setData(this.planList[0], true)
    },
  },

  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem('user'))
  },

  beforeDestroy() {
    this.audioList.forEach((a) => {
      if (a.audioElement) {
        a.audioElement.pause()
        a.audioElement = null
      }
    })
  },

  methods: {
    //设置数据
    setData(item, flag) {
      if (flag && item) {
        this.domainForm = { ...item }
        this.activeItemId = item.id
        if (item.itemList[0].sourceType != null) {
          this.loadTemplatesByType(item.itemList[0].sourceType, () => {
            const matched = this.teamplanList.find((t) => t.id === item.templateId)
            this.templateContent = matched ? matched.preViewContent : ''
          })
        }
      } else {
        this.resetForm()
      }
      this.domainFormCopy = JSON.parse(JSON.stringify(this.domainForm))
      this.updateUsedIds()
    },
    resetForm() {
      this.domainForm = {
        id: null,
        userId: this.userInfo.userId,
        orgId: this.userInfo.organizationId,
        name: null,
        itemList: [],
        templateId: 0,
        musicType: null,
        isOpen: 1,
        isRun: 1,
        isMuted: 1,
        isShowMedia: 1,
      }
      this.teamplanList = []
      this.templateContent = ''
    },

    /* 开关 */
    isShowComputedFn(val) {
      this.domainForm.isOpen = val ? 1 : 0
      this.domainForm.isRun = val ? 1 : 0
      this.saveInnerDrawer()
    },

    /* 打开数据源 */
    addData() {
      this.loadDataSource()
      this.itemListCope = JSON.parse(JSON.stringify(this.domainForm.itemList || []))
      this.tempItemList = JSON.parse(JSON.stringify(this.domainForm.itemList || []))
      this.dialogTableVisible = true
      this.$nextTick(() => {
        this.onscroll()
      })
    },
    async loadDataSource() {
      this.sourceType1 = []
      this.sourceType2 = []
      this.sourceType3 = []
      this.sourceType4 = []
      if (this.sourceType1.length) return
      try {
        this.loading = true
        const { data } = await domainSearch(this.userInfo.organizationId)
        if (data.code === 200) {
          data.data.forEach((item) => {
            if (item.sourceType === SOURCE_TYPE.PLAN) this.sourceType1.push(item) //为0是精准舆情
            else if (item.sourceType === SOURCE_TYPE.OPINION) this.sourceType2.push(item) //为1是监测
            else if (item.sourceType === SOURCE_TYPE.REALTIME) this.sourceType3.push(item) //为2是数据源
            else if (item.sourceType === SOURCE_TYPE.HOT) this.sourceType4.push(item) //为4是热点
          })
        }
      } finally {
        this.loading = false
      }
    },

    toggleDataSource(item) {
      const list = this.tempItemList
      const idx = list.findIndex((i) => i.sourceId === item.sourceId)
      if (idx > -1) {
        list.splice(idx, 1)
      } else {
        list.push({
          projectId: item.id,
          sourceId: item.sourceId,
          sourceName: item.sourceName,
          sourceType: item.sourceType,
        })
      }
    },

    //判断数据源状态
    isSelected(item) {
      return this.tempItemList.some((i) => i.sourceId === item.sourceId)
    },

    //判断是否可以点击
    isDisabled(item) {
      // 1. 被其它配置占用
      const occupiedIds = this.getOccupiedDataSourceIds()
      if (occupiedIds.includes(item.sourceId)) return true
      // 2. 只要弹窗里已选过源，就只能选同一种类型
      if (this.tempItemList.length) {
        return item.sourceType !== this.tempItemList[0].sourceType
      }
      return false
    },
    getOccupiedDataSourceIds() {
      const ids = []
      this.planList.forEach((plan) => {
        if (plan.id === this.domainForm.id) return
        if (Array.isArray(plan.itemList)) {
          plan.itemList.forEach((d) => {
            const id = d.sourceId ?? d.sourceId
            if (id != null) ids.push(id)
          })
        }
      })

      return ids
    },

    //删除数据源
    removeData(index, list = this.domainForm.itemList) {
      list.splice(index, 1)
      if (list === this.domainForm.itemList) {
        if (!this.domainForm.itemList.length) {
          this.teamplanList = []
          this.templateContent = ''
          this.domainForm.templateId = 0
        } else {
          const templateStillExists = this.teamplanList?.some((t) => t.id === this.domainForm.templateId)
          if (!templateStillExists) {
            this.domainForm.templateId = 0
            this.templateContent = ''
          }
        }
      }
    },

    //取消数据源弹窗
    canelData() {
      this.domainForm.itemList = JSON.parse(JSON.stringify(this.itemListCope))
      this.dialogTableVisible = false
    },

    // 确定数据源弹窗
    submitData() {
      const list = this.tempItemList
      if (!list || !list.length) return
      this.domainForm.itemList = JSON.parse(JSON.stringify(list))
      this.loadTemplatesByType(list[0].sourceType)
      this.dialogTableVisible = false
    },

    /* 模板渲染 */
    loadTemplatesByType: debounce(async function (type, cb) {
      // if (!type) return
      const { data } = await listInsert({
        pageNum: 1,
        pageSize: 1000,
        templateKind: type,
        organId: this.userInfo.organizationId,
        isType: 1,
      })
      if (data.code === 200) {
        if (data.data.length === 0) {
          this.teamplanList = [{
            id: '0abb987d-8cbc-11f0-a533-00163e040e1c',
            templateName: '通用模版',
            templateType: 0,
            templateKind: 0,
            preViewContent: '标题：<span style="color:red">嫌疑人当庭辱骂李圣律师，法官不管么？</span><br>链接：<span style="color:red">https://www.toutiao.com/a7493552896571687680</span><br>摘要：<span style="color:red">引用:嫌疑人当庭辱骂李圣律师，法官不管么？</span><br>调性：<span style="color:red">正面</span><br>媒体：<span style="color:red">视频</span><br>作者：<span style="color:red">会飞的猪</span><br>关键词：<span style="color:red">辱骂</span><br>发布时间：<span style="color:red">2025-04-15 22:52:47</span>',
            organId: null,
            organName: '',
            context: '标题：%&基础字段-标题%&\n链接：%&基础字段-链接%&\n摘要：%&基础字段-摘要%&\n调性：%&基础字段-调性%&\n媒体：%&基础字段-媒体%&\n作者：%&基础字段-作者%&\n关键词：%&基础字段-关键词%&\n发布时间：%&基础字段-发布时间%&',
            createTime: '2025-09-08 13:59:31',
            updateTime: '2025-09-09T01:53:53.000+00:00',
            pageNo: 1,
            pageSize: 10,
            isType: 0,
          }]
        } else {
          this.teamplanList = data.data
        }
      }
      cb && cb()
    }, 300),

    // 点击模板按钮
    setTemplate(item) {
      this.domainForm.templateId = item.id
      this.templateContent = item.preViewContent
    },

    //设置音频按钮
    setAudio(audio) {
      this.domainForm.musicType = audio.id
    },

    //播放声音
    playAuto(index) {
      const cur = this.audioList[index]
      if (cur.isPlaying && cur.audioElement) {
        cur.audioElement.pause()
        cur.audioElement.currentTime = 0
        cur.isPlaying = false
        return
      }
      this.audioList.forEach((a) => {
        if (a.audioElement) {
          a.audioElement.pause()
          a.audioElement.currentTime = 0
        }
        a.isPlaying = false
      })
      cur.isPlaying = true
      if (!cur.audioElement) cur.audioElement = new Audio(cur.src)
      cur.audioElement.play()
    },
    // 判断音频是否被其他数据占用
    isAudioDisabled(audio) {
      return this.usedAudioIds.includes(audio.id) && this.domainForm.musicType !== audio.id
    },
    updateUsedIds() {
      this.usedAudioIds = this.getUsedIds('musicType')
    },
    getUsedIds(key) {
      return this.planList.filter((p) => p[key] && p.id !== this.domainForm.id).flatMap((p) => (Array.isArray(p[key]) ? p[key].map((i) => i.sourceId) : [p[key]]))
    },

    /* 保存 / 取消大抽屉 */
    async saveInnerDrawer() {
      if (!this.domainForm.name) return this.$message.warning('请输入推送项目名称')
      if (!this.domainForm.itemList?.length) return this.$message.warning('请选择数据源')
      if (!this.domainForm.templateId) return this.$message.warning('请选择模板')
      if (!this.domainForm.musicType) return this.$message.warning('请选择提示音')
      try {
        const api = this.domainForm.id ? domainUpdate : domainAdd
        const { data } = await api(this.domainForm)
        if (data.code === 200) {
          this.$message.success(this.domainForm.id ? '编辑成功' : '新增成功')
          const newList = this.domainForm.id ? this.planList.map((item) => (item.id === this.domainForm.id ? this.domainForm : item)) : [...this.planList, data.data]
          this.$emit('update:planList', newList)
          this.$emit('closeDrawer', false)
          this.$emit('closeDrawersssss', false)
        } else {
          this.$message.warning(data.msg)
        }
      } catch {
        this.$message.warning('保存失败')
      }
    },

    // 重置所有数据
    // async resetFn() {
    //   this.domainForm = {}
    //   this.templateContent = ''
    //   this.teamplanList = []
    //   this.audioList = []
    //   this.usedAudioIds = []
    //   this.tempItemList = []

    //   const { data } = await domainUpdate(this.domainForm)
    //   if (data.code === 200) {
    //     this.$message.success('重置成功')
    //   } else {
    //     this.$message.warning(data.msg)
    //   }
    // },

    //取消设置弹窗
    cancelInnerDrawer() {
      this.domainForm = JSON.parse(JSON.stringify(this.domainFormCopy))
      if (this.domainForm.id) {
        const restoredPlanList = this.planList.map((item) => (item.id === this.domainForm.id ? { ...item, itemList: [...this.domainFormCopy.itemList] } : item))
        this.$emit('update:planList', restoredPlanList)
      }
      this.$emit('closeDrawer', false)
      this.$emit('closeDrawersssss', false)
    },

    // 修改后的goAssignBlock方法
    goAssignBlock(el) {
      const container = this.$refs.scrollContainer
      const section = this.$refs[el]
      if (container && section) {
        container.scrollTo({
          top: section.offsetTop - 120,
        })
        this.activeName = el
      }
    },

    // 修改后的onscroll方法
    onscroll() {
      const container = this.$refs.scrollContainer
      const sections = ['one', 'two', 'three']
      container.onscroll = () => {
        const scrollTop = container.scrollTop
        sections.forEach((section) => {
          const el = this.$refs[section]
          if (el) {
            const offsetTop = el.offsetTop - 120
            const offsetHeight = el.offsetHeight
            if (scrollTop >= offsetTop && scrollTop < offsetTop + offsetHeight) {
              this.activeName = section
            }
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* ========== 左侧列表 ========== */
.menu-list {
  padding: 30px 20px;
  width: 23%;

  .menu-list-item {
    height: 44px;
    line-height: 44px;
    background: rgba(253, 253, 253, 1);
    border-radius: 4px;
    padding: 0 20px;
    border: 2px dotted #cbceda;
    margin-bottom: 15px;
    cursor: pointer;
    //超出变省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background: #f0f4ff;
      border-color: #2e59ec;
    }

    &.active2 {
      background: rgba(248, 250, 255, 1);
      border: 1px solid rgba(237, 237, 237, 1);
      position: relative;
    }

    &.active3 {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 30px 30px 0;
        border-color: transparent #007bff transparent transparent;
      }

      &::after {
        content: '✓';
        position: absolute;
        top: -15px;
        right: 5px;
        color: white;
        font-size: 12px;
      }
    }

    &.selected {
      background: linear-gradient(313deg, #1a91ff 0, #2e59ec 100%) !important;
      border: none !important;
      color: #fff !important;
    }
  }
}

/* ========== 右侧设置 ========== */
.setBox {
  padding: 50px 30px 30px;
  height: calc(100vh - 1px);
  overflow: hidden;
  overflow-y: auto;
  padding-bottom: 98px;

  .setBox_top {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .setBox_top_text {
      margin-left: 10px;
    }
  }

  .setBox_content {
    .setBox_content_title {
      font-size: 16px;
      font-weight: bold;
      margin: 20px 0 15px;
    }
    .setBox_content_titleActive {
      &::before {
        content: '*';
        display: inline-block;
        color: red;
        margin-right: 10px;
      }
    }

    .setBox_content_title_btn {
      width: 142px;
      height: 32px;
      background: #fdfdfd;
      border: 2px dotted #cbceda;
      border-radius: 2px;
      text-align: center;
      line-height: 28px;
      cursor: pointer;
      color: #2e59ec;
    }

    .drawer-inner-content-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 10px 0 0;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
      background: #f5f6fa;
      border-radius: 4px;

      .close-icon {
        margin-left: 10px;
        cursor: pointer;
        color: #ea3342;
      }
    }

    .drawer-inner-content-item_audio {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

/* ========== 底部按钮 ========== */
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 2;

  .footer_btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px;
  }
}

/* ========== 通用 ========== */
.el-divider--horizontal {
  margin: 0;
}
.el-drawer__header {
  margin-bottom: 20px;
}

/* ========== 数据源弹窗 ========== */
.custom-dialog {
  .el-dialog__body {
    max-height: none;
    padding: 20px;
  }

  .custom-dialog-content {
    display: grid;
    grid-template-columns: 1fr 300px;

    .custom-dialog-content-left {
      display: grid;
      grid-template-columns: 120px auto;

      .custom-dialog-content-left-tabBox {
        overflow-y: auto;
        height: 380px;
        padding: 0 30px 0 0;

        .custom-dialog-content-left-tabBox-title {
          position: relative;
          padding-left: 10px;

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 4px;
            height: 100%;
            background: #165dff;
            border-radius: 0 4px 4px 0;
          }
        }

        .custom-dialog-content-left-tabBox-content {
          margin: 20px 0;
          grid-gap: 20px;
          display: flex;
          flex-wrap: wrap;
        }
      }
    }

    .custom-dialog-content-right {
      // width: 50%;
      border-left: 1px solid #e5e5e5;
      padding: 0 0 0 20px;

      .custom-dialog-content-right-title {
        color: #333;
        font-size: 16px;
      }

      .custom-dialog-content-right-content {
        height: 365px;
        overflow-y: auto;
        & > div {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 10px 10px 0 0;
          height: 32px;
          line-height: 32px;
          padding: 0 10px;
          background: #f5f6fa;
          border-radius: 4px;

          .custom-dialog-content-right-content-close {
            margin-left: 10px;
            cursor: pointer;
            color: #ea3342;
          }
        }
      }
    }
  }
}

/* ========== 滚动条美化 ========== */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(245, 247, 250, 0.1);
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #ccc;
}

// ::v-deep .el-switch__core{
//   height: 30px !important;
//   border-radius: 20px;

//   &::after{
//     width: 25px;
//     height: 25px;
//     // margin-left: -26px !important;
//   }
// }

/* 修改轨道高度和圆角 */
::v-deep .el-switch__core {
  height: 30px; /* 轨道高度 */
  border-radius: 20px;
}

::v-deep .el-switch.is-checked .el-switch__core::after {
  width: 25px;
  height: 25px;
  margin-left: -25px;
}

::v-deep .el-switch__core:after {
  width: 25px;
  height: 25px;
  margin-left: 0px;
}
</style>

<style src="@/assets/css/fiveBarIcon/iconfont.css" />
